module.exports = __webpack_public_path__ + "static/media/cover_2.584a6f15.jpg";